import { FeedbackGroupQuestionReportKeys } from "./keys";

export const englishValues = {
  [FeedbackGroupQuestionReportKeys.feedbackGroupQuestionReport_downloadAsPDFTooltip]:
    "Download as PDF",
  [FeedbackGroupQuestionReportKeys.feedbackIndividualView_emailTableHeader]:
    "Email",
  [FeedbackGroupQuestionReportKeys.feedbackIndividualView_nameTableHeader]:
    "Name",
  [FeedbackGroupQuestionReportKeys.feedbackIndividualView_actionsTableHeader]:
    "Actions",
  [FeedbackGroupQuestionReportKeys.feedbackIndividualView_viewReportLink]:
    "View report",
  [FeedbackGroupQuestionReportKeys.feedbackIndividualView_positionTableHeader]:
    "Position",
  [FeedbackGroupQuestionReportKeys.feedbackIndividualView_lastUpdatedTableHeader]:
    "Last updated",
  [FeedbackGroupQuestionReportKeys.feedbackReport_currentReportTab]:
    "Current Report",
  [FeedbackGroupQuestionReportKeys.feedbackReport_behaviouralChangeReportTab]:
    "Behavioural Change Report",
  [FeedbackGroupQuestionReportKeys.feedbackReport_newTag]: "New",
  [FeedbackGroupQuestionReportKeys.feedbackReport_vsLabel]: "vs",
  [FeedbackGroupQuestionReportKeys.feedbackReport_changeSelectionButton]:
    "Change selection",
  [FeedbackGroupQuestionReportKeys.feedbackReport_noPreviousCampaignsFound]:
    "No previous campaigns found",
  [FeedbackGroupQuestionReportKeys.feedbackReport_compareButton]: "Compare →",
  [FeedbackGroupQuestionReportKeys.feedbackReport_selectTeamFromLeft]:
    "Select a team from the left",
  [FeedbackGroupQuestionReportKeys.feedbackReport_statusTableHeader]: "Status",
  [FeedbackGroupQuestionReportKeys.feedbackReport_teamTableHeader]: "Team",
  [FeedbackGroupQuestionReportKeys.feedbackReport_somethingWentWrong]:
    "Something went wrong",
  [FeedbackGroupQuestionReportKeys.feedbackReport_oopsInvalidSurveyCampaign]:
    "Oops. Invalid survey campaign",
};

export const malayValues = {
  [FeedbackGroupQuestionReportKeys.feedbackGroupQuestionReport_downloadAsPDFTooltip]:
    "Muat turun sebagai PDF",
  [FeedbackGroupQuestionReportKeys.feedbackIndividualView_emailTableHeader]:
    "E-mel",
  [FeedbackGroupQuestionReportKeys.feedbackIndividualView_nameTableHeader]:
    "Nama",
  [FeedbackGroupQuestionReportKeys.feedbackIndividualView_actionsTableHeader]:
    "Tindakan",
  [FeedbackGroupQuestionReportKeys.feedbackIndividualView_viewReportLink]:
    "Tunjukkan laporan",
  [FeedbackGroupQuestionReportKeys.feedbackIndividualView_positionTableHeader]:
    "Jawatan",
  [FeedbackGroupQuestionReportKeys.feedbackIndividualView_lastUpdatedTableHeader]:
    "Dikemas kini pada",
  [FeedbackGroupQuestionReportKeys.feedbackReport_currentReportTab]:
    "Laporan Semasa",
  [FeedbackGroupQuestionReportKeys.feedbackReport_behaviouralChangeReportTab]:
    "Laporan Perubahan Tingkah Laku",
  [FeedbackGroupQuestionReportKeys.feedbackReport_newTag]: "Baharu",
  [FeedbackGroupQuestionReportKeys.feedbackReport_vsLabel]: "vs",
  [FeedbackGroupQuestionReportKeys.feedbackReport_changeSelectionButton]:
    "Tukar pilihan",
  [FeedbackGroupQuestionReportKeys.feedbackReport_noPreviousCampaignsFound]:
    "Tiada kempen sebelumnya dijumpai",
  [FeedbackGroupQuestionReportKeys.feedbackReport_compareButton]: "Bandingkan →",
  [FeedbackGroupQuestionReportKeys.feedbackReport_selectTeamFromLeft]:
    "Pilih pasukan di sebelah kiri",
  [FeedbackGroupQuestionReportKeys.feedbackReport_statusTableHeader]: "Status",
  [FeedbackGroupQuestionReportKeys.feedbackReport_teamTableHeader]: "Pasukan",
  [FeedbackGroupQuestionReportKeys.feedbackReport_somethingWentWrong]:
    "Sesuatu telah berlaku",
  [FeedbackGroupQuestionReportKeys.feedbackReport_oopsInvalidSurveyCampaign]:
    "Oops. Kempen tinjauan tidak sah",
};

export const chineseSimplifiedValues = {
  [FeedbackGroupQuestionReportKeys.feedbackGroupQuestionReport_downloadAsPDFTooltip]:
    "下载为PDF",
  [FeedbackGroupQuestionReportKeys.feedbackIndividualView_emailTableHeader]:
    "电子邮件",
  [FeedbackGroupQuestionReportKeys.feedbackIndividualView_nameTableHeader]:
    "姓名",
  [FeedbackGroupQuestionReportKeys.feedbackIndividualView_actionsTableHeader]:
    "操作",
  [FeedbackGroupQuestionReportKeys.feedbackIndividualView_viewReportLink]:
    "查看报告",
  [FeedbackGroupQuestionReportKeys.feedbackIndividualView_positionTableHeader]:
    "职位",
  [FeedbackGroupQuestionReportKeys.feedbackIndividualView_lastUpdatedTableHeader]:
    "更新于",
  [FeedbackGroupQuestionReportKeys.feedbackReport_currentReportTab]: "当前报告",
  [FeedbackGroupQuestionReportKeys.feedbackReport_behaviouralChangeReportTab]:
    "行为变化报告",
  [FeedbackGroupQuestionReportKeys.feedbackReport_newTag]: "新",
  [FeedbackGroupQuestionReportKeys.feedbackReport_vsLabel]: "对比",
  [FeedbackGroupQuestionReportKeys.feedbackReport_changeSelectionButton]:
    "更改选择",
  [FeedbackGroupQuestionReportKeys.feedbackReport_noPreviousCampaignsFound]:
    "未找到以前的活动",
  [FeedbackGroupQuestionReportKeys.feedbackReport_compareButton]: "比较 →",
  [FeedbackGroupQuestionReportKeys.feedbackReport_selectTeamFromLeft]:
    "从左侧选择团队",
  [FeedbackGroupQuestionReportKeys.feedbackReport_statusTableHeader]: "状态",
  [FeedbackGroupQuestionReportKeys.feedbackReport_teamTableHeader]: "团队",
  [FeedbackGroupQuestionReportKeys.feedbackReport_somethingWentWrong]:
    "出了点问题",
  [FeedbackGroupQuestionReportKeys.feedbackReport_oopsInvalidSurveyCampaign]:
    "哎呀，无效的调查活动",
};

export const chineseTraditionalValues = {
  [FeedbackGroupQuestionReportKeys.feedbackGroupQuestionReport_downloadAsPDFTooltip]:
    "下載為PDF",
  [FeedbackGroupQuestionReportKeys.feedbackIndividualView_emailTableHeader]:
    "電子郵件",
  [FeedbackGroupQuestionReportKeys.feedbackIndividualView_nameTableHeader]:
    "姓名",
  [FeedbackGroupQuestionReportKeys.feedbackIndividualView_actionsTableHeader]:
    "操作",
  [FeedbackGroupQuestionReportKeys.feedbackIndividualView_viewReportLink]:
    "查看報告",
  [FeedbackGroupQuestionReportKeys.feedbackIndividualView_positionTableHeader]:
    "職位",
  [FeedbackGroupQuestionReportKeys.feedbackIndividualView_lastUpdatedTableHeader]:
    "更新於",
  [FeedbackGroupQuestionReportKeys.feedbackReport_currentReportTab]: "當前報告",
  [FeedbackGroupQuestionReportKeys.feedbackReport_behaviouralChangeReportTab]:
    "行為變化報告",
  [FeedbackGroupQuestionReportKeys.feedbackReport_newTag]: "新",
  [FeedbackGroupQuestionReportKeys.feedbackReport_vsLabel]: "對比",
  [FeedbackGroupQuestionReportKeys.feedbackReport_changeSelectionButton]:
    "更改選擇",
  [FeedbackGroupQuestionReportKeys.feedbackReport_noPreviousCampaignsFound]:
    "未找到以前的活動",
  [FeedbackGroupQuestionReportKeys.feedbackReport_compareButton]: "比較 →",
  [FeedbackGroupQuestionReportKeys.feedbackReport_selectTeamFromLeft]:
    "從左側選擇團隊",
  [FeedbackGroupQuestionReportKeys.feedbackReport_statusTableHeader]: "狀態",
  [FeedbackGroupQuestionReportKeys.feedbackReport_teamTableHeader]: "團隊",
  [FeedbackGroupQuestionReportKeys.feedbackReport_somethingWentWrong]:
    "出了點問題",
  [FeedbackGroupQuestionReportKeys.feedbackReport_oopsInvalidSurveyCampaign]:
    "哎呀，無效的調查活動",
};
